"use client";

import { Carousel } from "react-bootstrap";

import testimonialsAndTopCategories from "../homepage-info.json";

import Button from "@/components/design-system/button";
import style from "./testimonials.module.scss";

export default function Testimonials() {
  const testimonials: Testimonial[] = testimonialsAndTopCategories.testimonials.Net32.map((t) => {
    return { ...t, testimonialText: t.testimonialText.replace("\n\n", "\n") };
  });

  return (
    <aside id={style["testimonials"]}>
      <div className={style["carousel-container"]}>
        <Carousel controls={false}>
          {testimonials.map((testimonial, index) => {
            return (
              <Carousel.Item key={index}>
                <div className={style["testimonial-content"]}>
                  <p className={style["testimonial-text"]}>&ldquo;{testimonial.testimonialText}&rdquo;</p>
                  <p className={`${style["testimonial-author"]} d-block`}>{testimonial.name}</p>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </div>
      <Button
        variant="secondary"
        className={style["read-more-button"]}
        text="Read More"
        showLeftIcon={false}
        rounded={false}
        color="blue"
        link={{ href: "/about-us/reviews" }}
      />
    </aside>
  );
}

type Testimonial = {
  name: string;
  /** @deprecated */
  imageURL: null;
  testimonialText: string;
};
